import React, { Component } from "react";

import {
  CLink,
  CButton,
  CSpinner,
  CSwitch,
  CLabel,
  CInput
} from "@coreui/react";
import PropTypes from "prop-types";
import ReactFlow, { removeElements, addEdge } from "react-flow-renderer";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import DuplicateTrailModal from "../../../../components/DuplicateTrailModal";
import ActivityEdge from "../../../../components/FlowEdges/ActivityEdge";
import ActivityNode from "../../../../components/FlowNodes/ActivityNode";
import InputNode from "../../../../components/FlowNodes/InputNode";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  databaseToFlowTrail,
  flowToDatabaseTrail,
  styleTrail
} from "../../../../utils/trail";

import "./style.css";

class TrailShow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trail: null,
      // duplicating: false,
      drag: true,
      elements: [],
      nodeTypes: {
        start: InputNode,
        activity: ActivityNode
      },
      edgeTypes: {
        default: ActivityEdge
      },
      editable: false,
      // saving: false,
      name: null,
      description: null,
      user_id: null,
      // private: false,
      flowInstance: null,
      duplicateTrailModal: false
    };

    this.div = React.createRef();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.getTrail();
  }

  addElement = (e, id, direction = "down") => {
    const newElements = [
      ...this.state.elements,
      e,
      {
        id: `e${id}-${e.id}`,
        source: direction === "up" ? e.id : id,
        target: direction === "up" ? id : e.id,
        type: "default",
        data: {
          temporary: true,
          first: null,
          operator: null,
          second: null
        }
      }
    ];

    this.setState(state => ({
      elements: styleTrail(
        newElements,
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        state.editable
      )
    }));
  };

  editElement = e => {
    const newElements = [...this.state.elements];

    newElements.find(item => item.id === e.id).data = e.data;

    this.setState(state => ({
      elements: styleTrail(
        newElements,
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        state.editable
      )
    }));
  };

  deleteElement = e => {
    this.setState(state => ({
      elements: removeElements(
        [state.elements.find(item => item.id === e)],
        state.elements
      )
    }));
  };

  setDrag = drag => {
    this.setState({ drag });
  };

  getTrail() {
    axios
      .get(`${URL.api}activity/trail/show/${this.props.match.params.id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            const elements = databaseToFlowTrail(
              resp.data.data.trail_activities,
              resp.data.data.trail_edges
            );

            const styledElements = styleTrail(
              elements,
              this.addElement,
              this.editElement,
              this.deleteElement,
              this.setDrag,
              // eslint-disable-next-line react/no-access-state-in-setstate
              this.state.editable
            );

            this.setState({
              trail: resp.data.data,
              name: resp.data.data.name,
              description: resp.data.data.description,
              // private: resp.data.data.private,
              user_id: resp.data.data.user_id,
              elements: styledElements,
              loading: false
            });
          } else {
            this.error("Não foi possível ver a trilha");

            this.setState({
              loading: false
            });
          }
        },
        error => {
          this.error("Não foi possível ver a trilha");

          this.setState({
            loading: false
          });
        }
      );
  }

  getPossibleTrails() {
    axios
      .get(`${URL.api}activity/trail/possible`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            // possibleTrails: [
            //   { id: null, name: "Todos", users: [{ id: null, name: "Todos" }] },
            //   ...resp.data.data.map(room => ({
            //     ...room,
            //     users: [{ id: null, name: "Todos" }, ...room.users]
            //   }))
            // ],
            // room: {
            //   value: null,
            //   label: "Todos"
            // }
          });
        },
        error => {
          this.error("Não foi possível listar as trilhas");
        }
      );
  }

  onElementsRemove = elementsToRemove => {
    this.setState(state => ({
      elements: removeElements(elementsToRemove, state.elements)
    }));
  };

  onConnect = params => {
    this.setState(state => ({
      elements: styleTrail(
        addEdge(
          {
            ...params,
            type: "default",
            data: {
              temporary: true,
              first: null,
              operator: null,
              second: null
            }
          },
          state.elements
        ),
        this.addElement,
        this.editElement,
        this.deleteElement,
        this.setDrag,
        // eslint-disable-next-line react/no-access-state-in-setstate
        this.state.editable
      )
    }));
  };

  deepDuplicate() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ duplicating: true, duplicateTrailModal: false });

    axios
      .post(
        `${URL.api}activity/trail/deep_duplicate/${this.props.match.params.id}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            // eslint-disable-next-line react/no-unused-state
            this.setState({ duplicating: false, loading: true }, () => {
              this.componentDidMount();
            });
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
            // eslint-disable-next-line react/no-unused-state
            this.setState({ duplicating: false });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
          // eslint-disable-next-line react/no-unused-state
          this.setState({ duplicating: false });
        }
      );
  }

  duplicate() {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ duplicating: true, duplicateTrailModal: false });

    axios
      .post(
        `${URL.api}activity/trail/duplicate/${this.props.match.params.id}`,
        {},
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push(`/trail/edit/${resp.data.data}`);
            // eslint-disable-next-line react/no-unused-state
            this.setState({ duplicating: false, loading: true }, () => {
              this.componentDidMount();
            });
          } else {
            toastr.error("Falha", "Não foi possível duplicar a trilha");
            // eslint-disable-next-line react/no-unused-state
            this.setState({ duplicating: false });
          }
        },
        () => {
          toastr.error("Falha", "Não foi possível duplicar a trilha");
          // eslint-disable-next-line react/no-unused-state
          this.setState({ duplicating: false });
        }
      );
  }

  onNodeDragStop() {
    this.setState(state => ({
      elements: state.flowInstance.getElements()
    }));
  }

  onLoad(flowInstance) {
    this.setState({ flowInstance });
  }

  render() {
    const { elements } = this.state;

    let isAlagoas =
      this.props.general.active_roles.group_id === 49 ||
      this.props.general.active_roles.group_id === 86;

    return (
      <div
        className="w-100 h-100 flex-column bg-light flex-1 d-flex align-items-center justify-content-center position-relative"
        ref={this.div}
      >
        <DuplicateTrailModal
          id={this.props.match.params.id}
          show={this.state.duplicateTrailModal}
          onClose={() => this.setState({ duplicateTrailModal: false })}
          onDuplicate={() => this.duplicate()}
          onDeepDuplicate={() => this.deepDuplicate()}
        />
        <div
          className="d-flex w-100 bg-white px-5"
          style={{
            zIndex: 1000,
            borderBottom: "1px solid rgba(0, 0, 0, 0.125)"
          }}
        >
          <div className="flex-1 px-4 py-3">
            <Breadcrumb
              current={this.props.currentRoute}
              items={
                isAlagoas
                  ? [{ path: "/trail/bank", to: "/trail/bank" }]
                  : [{ path: "/trail/list", to: "/trail/list" }]
              }
            />
            {this.state.editable ? (
              <CInput
                className="line-input h2 mb-1"
                value={this.state.name}
                onChange={e => this.setState({ name: e.target.value })}
              />
            ) : (
              <h2 className="mb-1" style={{ borderBottom: "1px solid white" }}>
                {!this.state.loading ? this.state.name : "Carregando trilha..."}
              </h2>
            )}
            {this.state.editable ? (
              <CInput
                className="line-input text-muted"
                value={this.state.description}
                onChange={e => this.setState({ description: e.target.value })}
              />
            ) : (
              <div
                className="text-muted"
                style={{ borderBottom: "1px solid white" }}
              >
                {!this.state.loading &&
                  this.state.user_id !== this.props.user.user.id && (
                    <span className="">
                      <CLink to={`/profile/${this.state.trail.user.id}`}>
                        <i className="fa fa-user mr-2"></i>{" "}
                        {this.state.trail.user.name}
                      </CLink>
                      <span className="mx-2 text-light">|</span>
                    </span>
                  )}
                {!this.state.loading
                  ? this.state.description
                  : "Aguarde mais um pouco"}
              </div>
            )}
          </div>
          {/* <div className="d-flex">
            <CButton
              color="primary"
              variant="ghost"
              block
              className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
              onClick={() =>
                this.props.history.push(
                  `/trail/allocate/${this.props.match.params.id}`
                )
              }
            >
              <i className="fa fa-calendar mb-2"></i>
              <span>Alocar</span>
            </CButton>
            <CButton
              color="primary"
              variant="ghost"
              block
              className="d-flex flex-column align-items-center justify-content-center rounded-0 m-0"
              onClick={() => this.setState({ duplicateTrailModal: true })}
              disabled={this.state.duplicating}
            >
              <i className="fa fa-copy mb-2"></i>
              <span>
                {this.state.duplicating ? "Copiando..." : "Fazer cópia"}
              </span>
            </CButton>
            </div> */}
        </div>
        {this.state.loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center flex-1">
            <Loading />
          </div>
        ) : (
          <>
            <svg height="0" width="0">
              <defs>
                <marker
                  className="react-flow__arrowhead"
                  id="react-flow__arrowclosedactive"
                  markerWidth="12.5"
                  markerHeight="12.5"
                  viewBox="-10 -10 20 20"
                  orient="auto"
                  refX="0"
                  refY="0"
                >
                  <polyline
                    stroke="var(--primary)"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    fill="var(--primary)"
                    points="-5,-4 0,0 -5,4 -5,-4"
                  ></polyline>
                </marker>
              </defs>
            </svg>
            <ReactFlow
              style={{ flex: 1 }}
              elements={elements}
              onElementsRemove={this.onElementsRemove}
              onConnect={this.onConnect}
              onNodeDragStop={() => this.onNodeDragStop()}
              onLoad={e => this.onLoad(e)}
              snapToGrid
              snapGrid={[15, 15]}
              connectionLineType="smoothstep"
              minZoom={1}
              maxZoom={1}
              defaultZoom={1}
              defaultPosition={[
                ((this.div.current?.offsetWidth || 0) - 200) / 2,
                0
              ]}
              onlyRenderVisibleElements
              nodesDraggable={this.state.drag && this.state.editable}
              zoomOnScroll={false}
              zoomOnPinch={false}
              panOnScroll
              panOnScrollMode="vertical"
              nodeTypes={this.state.nodeTypes}
              edgeTypes={this.state.edgeTypes}
              zoomOnDoubleClick={false}
              selectNodesOnDrag={false}
              translateExtent={[
                [-Infinity, 0],
                [Infinity, Infinity]
              ]}
              connectionLineStyle={{
                stroke: "var(--secondary)",
                strokeWidth: 2
              }}
            ></ReactFlow>
          </>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

TrailShow.propTypes = {
  hideContainer: PropTypes.bool
};

TrailShow.defaultProps = {
  hideContainer: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailShow);
